import React from "react";
import PropTypes from "prop-types";
import "../assets/_variables.scss";

const PopupAvis = ({
  isOpen,
  onClose,
  onAction,
  title,
  text,
  link,
  linkText,
  icon,
  closeButtonText ,
  actionButtonText,
  color = "#2D71E2",
}) => {
  if (!isOpen) return null;

  // Determine button classes based on color prop
  const closeBtnClass =
    color === "blue" ? "popup-close-btn" : "popup-close-btn";
  const actionBtnClass = color === "blue" ? "btn-primary" : "popup-action-btn";

  return (
    <div className="popup-overlay">
      <div className="popup-container popupAvis-container">
        <div className="d-flex justify-content-between">
        <h3 className="popup-title">{title}</h3>
         <button className="no-outline" onClick={onClose}>
            X
          </button>
        </div>
        <p className="popup-text">
          {text}
          {link && (
            <a
              href={link}
              className="popup-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkText}
            </a>
          )}
        </p>
        <div className=" row popup-actions">
          {actionButtonText && (
            <button className={`${actionBtnClass} avisBtn`} onClick={onAction} >
              {actionButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Optional: Prop type validation
PopupAvis.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
  linkText: PropTypes.string,
  icon: PropTypes.element,
  closeButtonText: PropTypes.string,
  actionButtonText: PropTypes.string,
  color: PropTypes.oneOf(["blue", "red"]),
};

export default PopupAvis;
